const NUMBER_OF_MONTHS_PER_YEAR = 12;

const CALCULATOR_CONSTANTS = {
  periodicLoanRepayment: 0,
  offsetBalanceStartingMonth: 0,
  additionalContributionsStartingMonth: 0,
  loanTermInMonths: 0,
  newLoanTermInMonths: 0,
};

const offsetAndContributions = [];
const periodicInterest = [];
const periodicOffsetInterest = [];
const balanceByYear = [];

function resetCalculatorConstants() {
  for (const property in CALCULATOR_CONSTANTS) {
     CALCULATOR_CONSTANTS[property] = 0;
  }
}

function setCalculatorConstants(inputs) {
  CALCULATOR_CONSTANTS.periodicLoanRepayment = calculatePeriodicLoanRepayment(inputs.loanAmount, inputs.interestRate, inputs.loanTerm);
  CALCULATOR_CONSTANTS.offsetBalanceStartingMonth = inputs.offsetStartsAfter * NUMBER_OF_MONTHS_PER_YEAR ;
  CALCULATOR_CONSTANTS.additionalContributionsStartingMonth = inputs.additionalContributionsStartAfter * NUMBER_OF_MONTHS_PER_YEAR;
  CALCULATOR_CONSTANTS.loanTermInMonths = inputs.loanTerm * NUMBER_OF_MONTHS_PER_YEAR;
}

function calculatePeriodicLoanRepayment(loanAmount, interestRate, loanTerm) {
  return loanAmount*(interestRate/12)/((1-(1+(interestRate/12))**(-12*loanTerm)));
}

function calculatePeriodicInterest(loanBalanceNetOffsetAmount, interestRate) {
  return loanBalanceNetOffsetAmount * interestRate / 12;
}

function calculateSumOfStartingOffsetBalanceAndAdditionalMonthlyContibution(previousSumOfStartingOffsetBalanceAndAdditionalMonthlyContibution, offsetBalanceLumpSum, additionalMonthlyContribution) {
  return previousSumOfStartingOffsetBalanceAndAdditionalMonthlyContibution + offsetBalanceLumpSum + additionalMonthlyContribution;
}

function calculateLoanBalanceNewNetOffsetAmount(loanBalanceAmortisation, offsetAndContributions) {
  return loanBalanceAmortisation - offsetAndContributions;
}

function calculateLoanBalanceAmortisation(previousLoanBalanceAmortisation, previousPrincipalRepayment) {
  return previousLoanBalanceAmortisation - previousPrincipalRepayment;
}

function calculatePrincipalRepayment(periodicOffsetInterest) {
  return CALCULATOR_CONSTANTS.periodicLoanRepayment - periodicOffsetInterest;
}


function populateMonthlyOffsetAndContributionsArray(startingOffsetAccountBalance, additionalOffsetMonthlyContributions) {
  offsetAndContributions.length = 0;
  for (let monthIndex = 0; monthIndex <= CALCULATOR_CONSTANTS.loanTermInMonths; monthIndex++) {
    const previousOffsetAndContributions = monthIndex === 0 ? 0 : offsetAndContributions[monthIndex-1];
    const offsetBalanceLumpSum = monthIndex === CALCULATOR_CONSTANTS.offsetBalanceStartingMonth ? startingOffsetAccountBalance : 0;
    const additionalContributions = monthIndex === 0 || monthIndex < CALCULATOR_CONSTANTS.additionalContributionsStartingMonth ? 0 : additionalOffsetMonthlyContributions;
    offsetAndContributions[monthIndex] = calculateSumOfStartingOffsetBalanceAndAdditionalMonthlyContibution(previousOffsetAndContributions, offsetBalanceLumpSum, additionalContributions);
  }
}

function populatePeriodicOffsetInterestArray(loanAmount, interestRate) {
  periodicOffsetInterest.length = 0;
  let loanBalanceAmortisation = loanAmount;
  let netBalance = calculateLoanBalanceNewNetOffsetAmount(loanBalanceAmortisation, offsetAndContributions[0]);
  let monthIndex = 1;
  periodicOffsetInterest[0] = 0;
  do {
    periodicOffsetInterest[monthIndex] = calculatePeriodicInterest(netBalance, interestRate);
    loanBalanceAmortisation = calculateLoanBalanceAmortisation(loanBalanceAmortisation, calculatePrincipalRepayment(periodicOffsetInterest[monthIndex]));
    if (monthIndex % 12 === 0) {
      const balanceIndex = monthIndex / 12;
      balanceByYear[balanceIndex].balanceOffset = Math.round(loanBalanceAmortisation);
    }
    netBalance = calculateLoanBalanceNewNetOffsetAmount(loanBalanceAmortisation, offsetAndContributions[monthIndex]);
    monthIndex++;
  } while (offsetAndContributions[monthIndex] <= loanBalanceAmortisation);
  CALCULATOR_CONSTANTS.newLoanTermInMonths = monthIndex - 1;

  // since there will be no more repayments after this period last interest calculation is not needed
  periodicOffsetInterest.pop();

  // remove fields for balanceOffset after balanceOffset reaches 0
  let i = balanceByYear.length - 1;
  while (balanceByYear[i - 1].balanceOffset === 0) {
    delete balanceByYear[i].balanceOffset;
    i--;
  }
}

function populatePeriodicInterestArray(loanAmount, interestRate) {
  periodicInterest.length = 0;
  balanceByYear.length = 0;
  let balance = loanAmount;
  balanceByYear[0] = {year: 0, balance: balance, balanceOffset: balance};
  for (let monthIndex = 1; monthIndex <= CALCULATOR_CONSTANTS.loanTermInMonths; monthIndex++) {
    periodicInterest[monthIndex] = calculatePeriodicInterest(balance, interestRate);
    balance = calculateLoanBalanceAmortisation(balance, calculatePrincipalRepayment(periodicInterest[monthIndex]));
    if (monthIndex % 12 === 0) {
      balanceByYear.push({year: balanceByYear.length, balance: Math.round(balance), balanceOffset: 0});
    }
  }
  balanceByYear[balanceByYear.length - 1].balance = 0;
}

export function returnOffsetCalculatorOutput(inputs) {
  resetCalculatorConstants();
  setCalculatorConstants(inputs);
  populateMonthlyOffsetAndContributionsArray(inputs.startingOffsetAccountBalance, inputs.additionalOffsetMonthlyContributions);
  populatePeriodicInterestArray(inputs.loanAmount, inputs.interestRate);
  populatePeriodicOffsetInterestArray(inputs.loanAmount, inputs.interestRate);

  const totalInterest = periodicInterest.reduce((a, b) => a + b, 0);
  const totalOffsetInterest = periodicOffsetInterest.reduce((a, b) => a + b, 0);

  const loanRepayment = CALCULATOR_CONSTANTS.periodicLoanRepayment;
  const interestSaved = totalInterest - totalOffsetInterest;
  const timeSaved = CALCULATOR_CONSTANTS.loanTermInMonths - CALCULATOR_CONSTANTS.newLoanTermInMonths;
  const newLoanTerm = CALCULATOR_CONSTANTS.newLoanTermInMonths;

  return {
    loanRepayment,
    interestSaved,
    timeSaved,
    newLoanTerm,
    graphData: balanceByYear,
  }
}
